/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const PassageListItemWrapper = styled.div`
  .lrn.lrn-author .lrn-tool-panel-search {
    padding: 0 !important;
  }
`;
